<template>
  <v-app dir="rtl">
    <v-snackbar
      v-model="alert.show"
      :color="alert.type"
      :timeout="alert.type === 'success' ? 3000 : 5000"
      location="top"
    >
      {{ alert.message }}
      <template v-slot:actions>
        <v-btn
          variant="text"
          @click="closeAlert"
        >
          إغلاق
        </v-btn>
      </template>
    </v-snackbar>

    <router-view></router-view>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapState({
      alert: state => state.alert
    })
  },
  methods: {
    closeAlert() {
      this.$store.commit('setAlert', { show: false, message: '', type: 'success' });
    }
  },
  created() {
    // Initialize auth state
    this.$store.dispatch('auth/initializeAuth');
    
    // Handle when the window regains focus
    window.addEventListener('focus', () => {
      // Check if token is still valid
      const token = localStorage.getItem('token');
      if (!token && this.$route.path !== '/login') {
        this.$router.push('/login');
      }
    });
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;700&display=swap');

#app {
  font-family: 'Cairo', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: initial;
}

.main-content {
  padding: 20px;
}
</style>
